import Title from "../components/TheTitle.vue";
import CouponInfo from "../components/CouponInfo.vue";
import { Validation } from "../utils/validation";
import { getBrandsMaster, getStoresMaster, searchUser, getCouponDetail, grantCoupon, } from "../api";
import { FormatDate } from "../utils/formatDate";
import { Authorize } from "../utils/authorize";
export default {
    name: "BulkCouponAllocationTargetSearch",
    data() {
        return {
            brandInfo: [],
            storeInfo: [],
            grantStoreInfo: [],
            couponCode: "",
            coupon: {},
            tableInfo: [],
            pageSize: 100,
            infoPage: 1,
            form: {
                customerId: "",
                phone: "",
                name: "",
                brand: "",
                store: "",
                dateFrom: "",
                dateTo: "",
                grantStore: "",
            },
            //保留情報
            selectedRows: [],
            grantDialogVisible: false,
            granting: false,
            imported: false,
        };
    },
    async created() {
        const route = this.$route;
        const codeFromParams = (route && route.params && route.params.couponCode) || "";
        // 優先順位は params > query
        this.couponCode = codeFromParams || "";
    },
    components: {
        Title,
        CouponInfo,
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    watch: {
        // データが変更されたらページを先頭に戻す
        info() {
            this.infoPage = 1;
        },
        "form.brand": async function (newBrand) {
            if (!newBrand) {
                this.storeInfo = [];
                this.form.store = "";
                return;
            }
            try {
                const response = await getStoresMaster(newBrand); // brandId を直接渡す
                if (response.result?.code === 9) {
                    this.$store.commit("setMessages", response.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    this.storeInfo = response.data.results || [];
                    // 選択中の store が新しい storeInfo に存在しない場合はクリアする
                    if (!this.storeInfo.find((s) => s.storeId === this.form.store)) {
                        this.form.store = "";
                    }
                }
            }
            catch (err) {
                //
            }
        },
    },
    methods: {
        setInfoPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.infoTotalPages)
                p = this.infoTotalPages;
            this.infoPage = p;
        },
        goCsvUpload() {
            this.$store.commit("setStoreInfo", this.form.grantStore);
            this.$router.push("/csvImport").catch(() => {
                /* NavigationDuplicated 等のエラーを無視 */
            });
        },
        toggleSelectAll() {
            // 表示中のみ切替ではなく、全件を対象にするか表示中のみかを切替えたい場合は別ボタンを用意する
            const allIds = this.tableInfo.map((r) => r.crm_customer_id);
            const allSelected = allIds.every((id) => this.selectedRows.includes(id));
            if (allSelected) {
                // 全解除
                this.selectedRows = [];
            }
            else {
                // 全選択（重複除去）
                this.selectedRows = Array.from(new Set([...this.selectedRows, ...allIds]));
            }
        },
        formatDate(value) {
            return FormatDate.withoutTime(value);
        },
        async onSearch() {
            const brandName = this.form.brand && this.brandInfo
                ? (this.brandInfo.find((b) => b.brandId === this.form.brand) ||
                    {}).brandName || null
                : null;
            const storeName = this.form.store && this.storeInfo
                ? (this.storeInfo.find((s) => s.storeId === this.form.store) ||
                    {}).storeName || null
                : null;
            const params = {
                crm_customer_ids: [this.form.customerId || ""],
                mobile_phone_number: (this.form.phone || null),
                name: (this.form.name || null),
                last_use_brand: (brandName || null),
                last_use_store: (storeName || null),
                last_use_at_from: (this.form.dateFrom || null),
                last_use_at_to: (this.form.dateTo || null),
            };
            const errorMessage = this.validate(params);
            if (errorMessage) {
                this.$store.commit("setMessages", errorMessage);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            const response = await searchUser(params.crm_customer_ids, params.mobile_phone_number, params.name, params.last_use_brand, params.last_use_store, params.last_use_at_from, params.last_use_at_to);
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.tableInfo = response.data.results;
                this.infoPage = 1;
                if (this.imported) {
                    this.selectedRows = [];
                    this.imported = false;
                }
            }
        },
        validate(params) {
            // エラーメッセージを格納する配列
            const errors = [];
            // 桁数チェック
            if (params.crm_customer_ids.length) {
                errors.push(...Validation.digitsMax({
                    key: "顧客ID",
                    value: params.crm_customer_ids[0],
                }, 20));
            }
            errors.push(...Validation.digitsMax({
                key: "電話番号",
                value: params.mobile_phone_number,
            }, 13));
            errors.push(...Validation.digitsMax({
                key: "氏名",
                value: params.name,
            }, 100));
            if (params.last_use_at_from &&
                params.last_use_at_to &&
                params.last_use_at_to < params.last_use_at_from) {
                errors.push("最終利用日のFromとToは、FromがToより小さくなるように入力してください。");
            }
            if (errors.length > 0) {
                return errors;
            }
            return "";
        },
        onClear() {
            this.form = {
                customerId: "",
                phone: "",
                name: "",
                brand: "",
                store: "",
                dateFrom: "",
                dateTo: "",
                grantStore: "",
            };
        },
        async onGrantClick() {
            if (this.granting)
                return;
            this.granting = true;
            try {
                const param = {
                    customerIds: this.selectedRows,
                    coupon_code: this.couponCode,
                    brand_id: this.coupon.brand_id,
                    store_id: this.form.grantStore,
                    granted_by: this.$store.state.displayName,
                };
                const rspBody = await grantCoupon(param.customerIds, param.coupon_code, param.brand_id, param.store_id, param.granted_by);
                if (rspBody.result.code === 9) {
                    if (rspBody.result.messages) {
                        this.$store.commit("setMessages", rspBody.result.messages);
                        this.$store.commit("setCancelBtnHide", true);
                        this.$store.commit("setIsModalOpen", true);
                    }
                }
                else {
                    const id = rspBody.data.coupon_bulk_operation_history_id;
                    this.selectedRows = [];
                    this.$store.commit("clearStoreInfo");
                    this.$router.push(`/couponGrantResult/${id}`).catch(() => {
                        /* NavigationDuplicated 等のエラーを無視 */
                    });
                }
            }
            catch (err) {
                alert("クーポン付与に失敗しました。");
            }
            finally {
                this.granting = false;
            }
        },
    },
    async mounted() {
        if (await Authorize.isExpired(this)) {
            // CSVインポート値取得
            if (this.$store.state.csvMatched) {
                this.tableInfo = this.$store.state.csvMatched;
                this.$store.commit("clearCsvMatched");
                const allIds = this.tableInfo.map((r) => r.crm_customer_id);
                this.selectedRows = Array.from(new Set([...this.selectedRows, ...allIds]));
                this.imported = true;
            }
            if (this.$store.state.storeInfo) {
                this.form.grantStore = this.$store.state.storeInfo;
            }
            const response = await getBrandsMaster();
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.brandInfo = response.data.results;
            }
            const gCResponse = await getCouponDetail(this.couponCode);
            if (gCResponse.result?.code === 9) {
                if (gCResponse.result?.messages) {
                    this.$store.commit("setMessages", gCResponse.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
            }
            else {
                this.coupon = gCResponse.data;
            }
            const gSResponse = await getStoresMaster(gCResponse.data.brand_id);
            if (gSResponse.result?.code === 9) {
                this.$store.commit("setMessages", gSResponse.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.grantStoreInfo = gSResponse.data.results;
            }
        }
    },
};
